// extracted by mini-css-extract-plugin
export var required = "_f3-0";